mutation PublishTemplate($input: TemplatePublishInput!) {
    templatePublish(input: $input) {
        template {
            name
            id
            status
            edition {
                id
                status
            }
        }
    }
}
